import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { agregarOrigenReclamoAction ,modificarOrigenReclamoAction } from "../../../../actions/reclamos/abmReclamosActions";


const useStyles = makeStyles({
    botonera: {
        padding: 25
    }
});

export const FormOrigenesReclamos = ({ formData, editable, handleCancel }) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [descripcion, setDescripcion] = useState(!!formData ? formData.descripcion : "");

    const handleSave = (e) => {
        e.preventDefault()
        if (!formData){
            dispatch(agregarOrigenReclamoAction(descripcion))
        }
        else{
            dispatch(modificarOrigenReclamoAction({id: formData.id, descripcion: descripcion}));
        }
        handleCancel()
    };

    return (
        <ValidatorForm onSubmit={handleSave}>
            <Grid container style={{ padding: 25 }}>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Descripcion"
                        value={descripcion}
                        autoComplete="off"
                        onChange={(e)=>{setDescripcion(e.target.value)}}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                        errorMessages={["La descripción es requerida"]}
                    />
                </Grid>
                <Grid container className={classes.botonera} >
                    <Grid item xs={12}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<CancelIcon />}
                                onClick={handleCancel}
                            >
                                CANCELAR
                            </Button>
                            {
                                editable &&

                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<SaveIcon />}
                                    type='submit'
                                    style={{ marginLeft: "0.5rem" }}
                                >
                                    GUARDAR
                                </Button>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ValidatorForm>
    );
};
export default FormOrigenesReclamos;